const init = () => {

	// For each filters component
	for (const el of document.querySelectorAll('[data-filters]')) {

		// Get id of this filters set
		const id = el.getAttribute('data-filters');

		// Add event listener for when 'update results' clicked
		el.querySelector('[data-filters-confirm-trigger]').addEventListener('click', (e) => {
			handleConfirmClick(e, id);
		});

		// Add event listener for when 'clear selection' clicked
		el.querySelector('[data-filters-clear-trigger]').addEventListener('click', handleClearClick);
	}
}

const handleConfirmClick = (e, id) => {
	
	e.target.dispatchEvent(new CustomEvent('filters-updated', {
		bubbles: true,
		detail: id
	}));
}

const handleClearClick = (e) => {

	// Get parent filters set
	const filtersSet = e.target.closest('[data-filters]')

	// Loop through all filter fields in set
	for (const filterFld of filtersSet.querySelectorAll('[data-filters-field]')) {

		// Uncheck filter field
		filterFld.checked = false
	}
}

export default init